
export default {
  props: {
    store: {type: Object, required: true}
  },
  emits: ['update'],
  data() {
    return {
      value: this.store.feed_digest_days || ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      options: [
        {value: 'monday', label: 'Monday'},
        {value: 'tuesday', label: 'Tuesday'},
        {value: 'wednesday', label: 'Wednesday'},
        {value: 'thursday', label: 'Thursday'},
        {value: 'friday', label: 'Friday'},
        {value: 'saturday', label: 'Saturday'},
        {value: 'sunday', label: 'Sunday'},
      ]
    }
  },
  computed: {
    my_store() {
      return this.store
    }
  },
  watch: {
    value(val) {
      const order = this.options.map(o => o.value)
      const sorted = [...val].sort((a, b) => order.indexOf(a) - order.indexOf(b))
      if (sorted.join() !== val.join()) {
        this.value = sorted
        return
      }
      this.my_store['feed_digest_days'] = sorted
      this.$emit('update')
    }
  },
}
